import { mutationOptions } from '@tanstack/react-query';
import { ADDRESS_QUERY_KEYS } from './keys';
import { addressAPIClient } from '../addressAPIClient';
import type { NormalizeAddressRequest } from './types';

export const ADDRESS_QUERIES = {
  normalizeAddress: () =>
    mutationOptions({
      mutationFn: (payload: NormalizeAddressRequest) => addressAPIClient.normalizeAddress(payload),
      mutationKey: ADDRESS_QUERY_KEYS.normalize(),
    }),
};
